export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-3" data-testid="brand-logo">
    <span className={`flex shrink-0 items-center justify-center ${light ? 'rounded-sm bg-ivory p-1' : ''}`}>
      <img src="/logo.png" alt="Yoeli Chan Journey" className="h-10 w-10 object-contain" />
    </span>
    <span className="leading-none">
      <span className={`block whitespace-nowrap font-heading text-base font-medium tracking-[0.22em] ${light ? 'text-ivory' : 'text-navy'}`}>
        YOELI CHAN
      </span>
      <span className="mt-1 block text-[9px] font-medium tracking-[0.5em] text-gold">
        JOURNEY
      </span>
    </span>
  </span>
);
